import React, {
  useRef,
  useImperativeHandle,
  forwardRef,
  useEffect,
} from "react";
import { useMediaQuery, Box, Typography } from "@mui/material";
import TextInputField from "../../../../utils/Fields/TextInputField";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import DetailsTextArea from "./DetailsTextArea";
import detailsValidations from "./dataValidations";
import PropTypes from "prop-types";
import { TextArea } from "pepsico-ds";
const Details = forwardRef(
  (
    { setDescription, description, onFormSubmit, images, populateData }, // Accept onSubmit from parent
    ref
  ) => {
    const isMobile = useMediaQuery("(max-width:600px)");
    const isSmallOrMedium = useMediaQuery("(max-width: 800px)");
    const isDarkTheme = useSelector((store) => store.theme);

    const {
      register,
      handleSubmit,
      formState: { errors },
      setError,
      reset,
    } = useForm({
      defaultValues: {
        headline: "",
        buttonText: "",
        descriptionLink: "",
      },
    });
    const editorRef = useRef(null);

    useEffect(() => {
      if (populateData) {
        reset({
          headline: populateData.headline || "",
          buttonText: populateData.buttonText || "",
          descriptionLink: populateData.descriptionLink || "",
        });
      }
    }, [populateData, reset]);

    const onSubmit = (data) => {
      const validationErrors = detailsValidations(
        data.headline,
        data.buttonText,
        data.descriptionLink
      );

      if (Object.keys(validationErrors).length > 0) {
        // Set errors for specific fields
        Object.entries(validationErrors).forEach(([field, message]) => {
          setError(field, { type: "manual", message });
        });
        return; // Prevent form submission
      }

      onFormSubmit(data); // Call parent's submit handler
    };

    // Expose the submit handler to the parent via ref
    useImperativeHandle(ref, () => ({
      triggerSubmit: () => handleSubmit(onSubmit)(),
    }));

    return (
      <form
        className="flex flex-col gap-6"
        onSubmit={handleSubmit(onSubmit)}
        id="landing-form"
      >
        {/* Headline Input */}
        <TextInputField
          label="Headline"
          errors={errors}
          register={register}
          name="headline"
          width={isSmallOrMedium ? "100%" : "400px"}
          required={true}
          isMobile={isMobile}
          placeholder="Type Here"
          maxLength={70}
        />

        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "12px",
              mb: 1,
              color: isDarkTheme ? "white" : "black",
            }}
          >
            Description
          </Typography>
          <DetailsTextArea
            editorRef={editorRef}
            isDarkTheme={isDarkTheme}
            setDescription={setDescription}
            populateData={populateData}
          />
        </Box>

        {/* Button Text Input */}
        <TextInputField
          label="Button text"
          errors={errors}
          placeholder="Type Here"
          register={register}
          name="buttonText"
          width={isSmallOrMedium ? "100%" : "400px"}
          required={true}
          isMobile={isMobile}
        />

        <TextInputField
          label="Destination Link"
          placeholder="Type Here"
          errors={errors}
          register={register}
          name="descriptionLink"
          width={isSmallOrMedium ? "100%" : "400px"}
          required={true}
          isMobile={isMobile}
        />
      </form>
    );
  }
);
Details.propTypes = {
  setDescription: PropTypes.func.isRequired, // Required function to set the description
  description: PropTypes.string, // Optional string for the description
  onFormSubmit: PropTypes.func.isRequired, // Required function for form submission
  images: PropTypes.array, // Optional array of images
  populateData: PropTypes.shape({
    headline: PropTypes.string,
    buttonText: PropTypes.string,
    descriptionLink: PropTypes.string,
  }), // Optional object with specific fields
};
export default Details;
